
<template>
  <div id="app">
    <transition
      leave-active-class="opacityOut"
      enter-active-class="opacityIn"
      mode="out-in"
      appear
    >
      <router-view v-if="isRouterAlive" />
    </transition>
    <van-number-keyboard safe-area-inset-bottom />
  </div>
</template>
<script>
export default {
  name: "APP",
  data() {
    return {
      isRouterAlive: true,
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
  mounted() {
  
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
};
</script>
<style lang="scss" >
// .van-field__control{
//     color: #000;
// }
.van-field__control--right {
  color: #fff;
}
html,
body {
  height: 100%;
  width: 100%;
}

.top .van-tabs--card {
  height: 55px;
  .van-tabs__wrap {
    height: 55px;
    .van-tabs__nav--card {
      box-sizing: border-box;
      height: 55px;
      margin: 0;
      border: none;
      border-radius: 0.05333rem;
      border-bottom: 2px solid #118eea;
      .van-tab {
        color: #118eea;
        border-right: none;
        height: 55px;
        font-size: 18px;
      }
      .van-tab.van-tab--active {
        height: 55px;
        color: #fff;
        background-color: #118eea !important;
        font-size: 18px;
        .tianjiaa {
          color: #fff;
        }
      }
    }
  }
}

.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.van-field__right-icon {
  color: #fff;
}
@font-face {
  font-family: "iconfont"; /* project id 2182572 */
  src: url("http://at.alicdn.com/t/font_2182572_wfai57yo0s9.eot");
  src: url("http://at.alicdn.com/t/font_2182572_wfai57yo0s9.eot?#iefix")
      format("embedded-opentype"),
    url("http://at.alicdn.com/t/font_2182572_wfai57yo0s9.woff2") format("woff2"),
    url("http://at.alicdn.com/t/font_2182572_wfai57yo0s9.woff") format("woff"),
    url("http://at.alicdn.com/t/font_2182572_wfai57yo0s9.ttf")
      format("truetype"),
    url("http://at.alicdn.com/t/font_2182572_wfai57yo0s9.svg#iconfont")
      format("svg");
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}
</style>
